import { fileTypeConfigs, fileTypes } from "../../consts";
import { fileUtils } from "../../utils";

const uploadImage = async (url, binaryImage) => {
  const response = await fetch(url, {
    method: "PUT",
    body: binaryImage
  });

  return response;
};

const fetchImage = async (url) => {
  const response = await fetch(url, {
    method: "GET"
  });

  return response;
};

const downloadImage = async (imageUrl, extention) => {
  if (imageUrl) {
    const res = await fetchImage(imageUrl);

    if (res) {
      const blob = await res.blob();

      if (blob) {
        const mediaType = fileTypeConfigs[fileTypes.media].extensions.find((ext) =>
          ext.includes(extention)
        );

        const imageFile = fileUtils.getFileBlob(blob, mediaType);
        const imageSrc = URL.createObjectURL(imageFile);

        return { imageFile, imageSrc };
      }
    }
  }
};

/**
 * Service for uploading and downloading images to and from S3 signed url
 */
const s3ImageService = {
  uploadImage,
  downloadImage
};

export default s3ImageService;
